import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PauseIcon from '@mui/icons-material/Pause'
import Chip from '@mui/material/Chip'
import HeadphonesIcon from '@mui/icons-material/Headphones'

export default function RecordingPlayer({ recordingUrl, duration }) {
  const [playing, setPlaying] = React.useState(false)
  const audioRef = React.useRef(null)

  const formatDuration = (secs) => {
    if (!secs) return '0:00'
    const m = Math.floor(secs / 60)
    const s = Math.round(secs % 60)
    return `${m}:${s.toString().padStart(2, '0')}`
  }

  const toggle = () => {
    if (!audioRef.current) return
    if (playing) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }
    setPlaying(!playing)
  }

  if (!recordingUrl) {
    return (
      <Chip
        icon={<HeadphonesIcon />}
        label='No recording'
        size='small'
        variant='outlined'
        sx={{ color: 'text.disabled' }}
      />
    )
  }

  return (
    <Box className='recording-player'>
      <IconButton size='small' onClick={toggle} sx={{ bgcolor: 'primary.main', color: '#fff', '&:hover': { bgcolor: 'primary.dark' }, width: 32, height: 32 }}>
        {playing ? <PauseIcon sx={{ fontSize: 18 }} /> : <PlayArrowIcon sx={{ fontSize: 18 }} />}
      </IconButton>
      <audio
        ref={audioRef}
        src={recordingUrl}
        onEnded={() => setPlaying(false)}
        preload='none'
      />
      <Typography variant='caption' sx={{ fontWeight: 600, color: 'text.secondary', minWidth: 36 }}>
        {formatDuration(duration)}
      </Typography>
    </Box>
  )
}
